import * as React from 'react';

import * as founder from './founder.module.scss';

export const Founder = ({ photo, sectionClassName, titleClassName, quoteBg, quoteIcon }) => {
  return (
    <section className={sectionClassName || `${founder.founder}`}>
      <div className="container">
        <div className={`row ${founder.founder__row}`}>
          <div className={`col-12 col-md-6 ${founder.founder__colFirst}`}>
            <img
              className={founder.founder__img}
              src={photo || "https://fs.advance.ru/landing-pages/online/uchis_uchitsya_old/nya2.png"}
              alt={'Николай Ягодкин'}
            />
            <div
              className={founder.founder__wrapper}
              style={{
                backgroundColor: quoteBg || '#f3e7ff',
                backgroundImage: `url(${quoteIcon})` || `url("https://fs.advance.ru/landing-pages/online/uchis_uchitsya_old/quotes.png")`
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="86" height="76" viewBox="0 0 86 76" fill="none">
                <path d="M0 75.582L57.5231 0.304891L85.9296 64.2194L0 75.582Z" fill={quoteBg || '#F3E7FF'}/>
              </svg>
              <p className={`${founder.founder__text} ${founder.founder__textFirst}`}>
                <i>
                  &laquo;У&nbsp;каждого человека огромный потенциал. Моя миссия&nbsp;&mdash; улучшать жизнь людей через
                  раскрытие этого потенциала&raquo;
                </i>
              </p>
            </div>
          </div>
          <div className={`col-12 col-md-6 ${founder.founder__colSecond}`}>
            <h2 className={titleClassName || `${founder.founder__title}`}>
              Основатель Центра и&nbsp;автор методики&nbsp;&mdash; Николай Ягодкин
            </h2>
            <p className={founder.founder__text}>
              Специалист по&nbsp;технологиям ускоренного обучения и&nbsp;изучению иностранных языков с&nbsp;20-летним
              практическим опытом.
            </p>
            <p className={founder.founder__text}>
              Консультирует и&nbsp;обучает политиков, предпринимателей, а&nbsp;также топ-менеджмент
              &laquo;Сбербанка&raquo;, &laquo;Альфа Банка&raquo;, &laquo;АФК Системы&raquo; и&nbsp;других известных
              компаний.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
